class ImperiaStoryRail extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.isDragging = false;
    this.didDrag = false;
    this.startX = 0;
    this.startScrollLeft = 0;

    this.addEventListener('pointerdown', this.onPointerDown);
    this.addEventListener('pointermove', this.onPointerMove);
    this.addEventListener('pointerup', this.onPointerUp);
    this.addEventListener('pointercancel', this.onPointerUp);
    this.addEventListener('click', this.onClick, true);
    this.addEventListener('keydown', this.onKeyDown);
    this.addEventListener('dragstart', (event) => event.preventDefault());
  }

  onPointerDown = (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    this.isDragging = true;
    this.didDrag = false;
    this.startX = event.clientX;
    this.startScrollLeft = this.scrollLeft;
    this.classList.add('is-dragging');
    this.setPointerCapture(event.pointerId);
  };

  onPointerMove = (event) => {
    if (!this.isDragging) return;
    const distance = event.clientX - this.startX;
    if (Math.abs(distance) > 4) this.didDrag = true;
    this.scrollLeft = this.startScrollLeft - distance;
  };

  onPointerUp = (event) => {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.classList.remove('is-dragging');
    if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
  };

  onClick = (event) => {
    if (!this.didDrag) return;
    event.preventDefault();
    event.stopPropagation();
    this.didDrag = false;
  };

  onKeyDown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    const card = this.querySelector('.imperia-featured-stories__card');
    const distance = card ? card.getBoundingClientRect().width + 22 : this.clientWidth * 0.8;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scrollBy({
      left: event.key === 'ArrowRight' ? distance : -distance,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  };
}

if (!customElements.get('imperia-story-rail')) {
  customElements.define('imperia-story-rail', ImperiaStoryRail);
}
